import React, { useEffect } from 'react';

const tags = [
  'description',
  'keywords',
  'og:title',
  'og:description',
  'og:type',
  'og:site_name',
];

const nameValues = ['description', 'keywords'];

const mappings = {
  description: 'description',
  keywords: 'keywords',
  'og:title': 'ogTitle',
  'og:description': 'ogDescription',
  'og:type': 'ogType',
  'og:site_name': 'ogSiteName',
};

function SeoHead({ data }) {
  useEffect(() => {
    if (!data) return;

    // Update existing meta tags
    const metaTags = document.getElementsByTagName('meta');
    for (let tag of metaTags) {
      const property = tag.attributes.getNamedItem('property')?.value;
      const name = tag.attributes.getNamedItem('name')?.value;
      if (tags.includes(name) || tags.includes(property)) {
        tag.setAttribute(
          'content',
          data[mappings[name]] ?? data[mappings[property]] ?? '',
        );
      }
    }

    // Create and append missing meta tags
    for (let key of tags) {
      let tagExists = false;
      for (let tag of metaTags) {
        const property = tag.attributes.getNamedItem('property')?.value;
        const name = tag.attributes.getNamedItem('name')?.value;
        if (property === key || name === key) {
          tagExists = true;
          break;
        }
      }

      if (!tagExists) {
        const metaTag = document.createElement('meta');
        metaTag.setAttribute(
          nameValues.includes(key) ? 'name' : 'property',
          key,
        );
        metaTag.setAttribute('content', data[mappings[key]] ?? '');
        document.head.appendChild(metaTag);
      }
    }

    // Update title tag
    const titleTags = document.getElementsByTagName('title');
    for (let tag of titleTags) {
      tag.innerText = data.title || '';
    }
  }, [data]);

  return <></>;
}

export default SeoHead;
